<template>
  <v-card elevation="0" rounded :color="$vuetify.theme.themes.light.primary.darken4">
    <v-card-title>{{ shootingInformations.registration }}</v-card-title>
    <v-card-text class="px-8">
      <v-row class="white px-3 mb-1 rounded-lg">
        <ShootingDetailContent
          :title="$t('shooting.details.shootingDate')"
          :content="creationDateFormated"
          contentType="text"
        />
        <ShootingDetailContent
          :title="$t('shooting.details.images')"
          :content="totalImages.toString()"
          contentType="text"
        />
        <ShootingDetailContent
          v-if="shootingInformations.model"
          :title="$t('shooting.details.model')"
          :content="shootingInformations.model"
          contentType="text"
        />
        <ShootingDetailContent
          v-if="shootingInformations.status"
          :title="$t('shooting.details.status')"
          :content="shootingInformations.status"
          contentType="status"
        />
        <ShootingDetailContent
          v-if="shootingInformations.ownerId"
          :title="$t('shooting.details.stock')"
          :content="removeUnderscoreAndMakeItUpercase(shootingInformations.ownerId)"
          contentType="text"
        />
        <ShootingDetailContent
          v-if="userInformationShooterName"
          :title="$t('shooting.details.creator')"
          :content="userInformationShooterName"
          contentType="text"
        />
        <ShootingDetailContent v-if="vin" :title="$t('shooting.details.vin')" :content="vin" contentType="text" />
        <ShootingDetailContent
          v-if="shootingInformations.brand"
          :title="$t('shooting.details.brand')"
          :content="shootingInformations.brand"
          contentType="text"
        />
        <ShootingDetailContent
          v-for="(stamp, index) in stamps"
          :key="index"
          :title="index == 0 ? $t('shooting.details.stamp') : ' '"
          :content="stamp.name"
          contentType="text"
        />
      </v-row>
      <v-row v-if="activeSwitch">
        <v-col cols="12" class="d-flex justify-center">
          <label class="text-center text-subtitle-1 mr-4 mt-5 font-weight-medium">{{
            $t('shooting.header.simpleView')
          }}</label>
          <v-switch v-model="details" class="switch-custom" inset @change="switchChange"></v-switch>
          <label class="text-center text-subtitle-1 mt-5 ml-4 font-weight-medium">{{
            $t('shooting.header.detailedView')
          }}</label>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { productType } from '@/enums'
import { removeUnderscoreAndMakeItUpercase } from '@/utils/index'
import moment from 'moment'
import { mapGetters } from 'vuex'
import ShootingDetailContent from './ShootingDetailContent.vue'

export default {
  name: 'ShootingDetailsCard',
  components: {
    ShootingDetailContent
  },
  props: {
    shootingInformations: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        videoName: '',
        registration: '',
        productType: null,
        ownerId: '',
        vin: '',
        brand: '',
        model: '',
        status: null
      })
    },
    totalImages: {
      type: Number,
      default: 0
    },
    activeSwitch: {
      type: Boolean,
      default: false
    },
    stamps: {
      type: Array,
      default: () => []
    },
    createdAt: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['userInformationShooterName']),
    vin() {
      if (this.shootingInformations.productType === productType.VIRTUAL) {
        return this.shootingInformations.vin.slice(0, 15) + '...'
      }

      return this.shootingInformations.vin
    },
    creationDateFormated() {
      if (!this.createdAt) return ''
      return moment(this.createdAt).format('DD/MM/YYYY - HH:mm:ss')
    }
  },
  data() {
    return {
      details: false
    }
  },
  methods: {
    removeUnderscoreAndMakeItUpercase,
    switchChange() {
      this.$emit('switchChange', this.details)
      this.$mam.shootingsViewShooting(this.details)
    }
  }
}
</script>
<style scoped lang="sass">
::v-deep
   .v-input--switch__thumb


     &.primary--text
       background-color: white !important

   .v-input--switch__track

     &.primary--text
       opacity: 1
   .v-input--selection-controls__ripple
     &.primary--text
       color: var(--v-primary-base) !important
</style>
